import React, { useContext, useEffect, useRef } from 'react';
import { View } from 'react-native';
import { LeftFrame } from './LeftFrame';
import RightFrame from './RightFrame';
import AppContext, { AppActions } from '../../contexts/App';
import LayoutContext, { MODERN_LAYOUT_COLLAPSE_WIDTH } from '../../contexts/Layout';
import { Snack } from '../../componentsv2/common/Snack';
import MobileFrame from './MobileFrame';
import ElasticViewContainer from '../../componentsv2/common/ElasticViewContainer';

export const ModernLayout = ({ followContentLink, goBack }) => {
    const { state, dispatch } = useContext(AppContext);
    const { layout } = useContext(LayoutContext);
    const isCollapsed = state.navigation.primaryIsCollapsed;
    const leftFrameWidth = isCollapsed ? Math.ceil(layout.dimensions.width * 0.05) : Math.ceil(layout.dimensions.width * 0.4);
    const rightFrameWidth = isCollapsed ? layout.dimensions.width - leftFrameWidth : Math.ceil(layout.dimensions.width * 0.6);
    const includeSnack = __DEV__ && layout.dimensions.width >= 800;

    useEffect(() => {
        const setIsCollapsed = value => {
            if (state.navigation.primaryIsCollapsed === value) return;

            dispatch({
                type: AppActions.COLLAPSE_PRIMARY_CHANGE,
                payload: value
            });
        };

        const pathname = state.action.href || window?.location?.pathname;

        if (
            !pathname ||
            pathname.equals('/') ||
            pathname.indexOf('/speaker-pages') !== -1 ||
            pathname.indexOf('/event') !== -1 ||
            pathname.indexOf('/visit') !== -1 ||
            pathname.indexOf('/article') !== -1 ||
            pathname.indexOf('/ministry-programs') !== -1 ||
            pathname.indexOf('/jobs') !== -1 ||
            pathname.indexOf('/campuses') !== -1 ||
            pathname.indexOf('email-subscription') !== -1 ||
            pathname.indexOf('/watch') !== -1
        ) {
            setIsCollapsed(false);
        } else if (pathname.indexOf('/featured-service') !== -1 || pathname.indexOf('/sermon-carousel') !== -1) {
            setIsCollapsed(true);
        } else {
            setIsCollapsed(pathname.substring(1, pathname.length - 1).split('/').length > 1);
        }
    }, [state.action.href, state.navigation.primaryIsCollapsed, dispatch]);

    if (layout.dimensions.width <= MODERN_LAYOUT_COLLAPSE_WIDTH || layout.device.isTablet) {
        return (
            <View style={{ flexDirection: 'row', height: layout.dimensions.height, width: layout.dimensions.width }}>
                <MobileFrame followContentLink={followContentLink} />
            </View>
        );
    } else {
        return (
            <View style={{ flexDirection: 'row', height: layout.dimensions.height, width: layout.dimensions.width }} testID='Modern'>
                <ElasticViewContainer width={leftFrameWidth}>
                    <LeftFrame cacheHit={state.action?.data?.cacheHit} />
                </ElasticViewContainer>
                <ElasticViewContainer width={rightFrameWidth}>
                    <RightFrame followContentLink={followContentLink} goBack={goBack} physicalWidth={rightFrameWidth} />
                </ElasticViewContainer>
                {includeSnack && <Snack leftFrameWidth={leftFrameWidth} rightFrameWidth={rightFrameWidth} />}
            </View>
        );
    }
};
